import React from 'react'
import { Card, Button, Box, Container, Typography } from '@mui/material'
import { ContractDTO } from '../../../../dto/ContractDTO'

type Props = {
  contratosList: ContractDTO[]
  contactoLocal: any
  handleClick: (acciones: any) => void
}

const DisplayContractsMobile: React.FC<Props> = ({ contratosList, contactoLocal, handleClick }) => {
  return (
    <>
      <Container style={{ marginBottom: '100px' }}>
        {contratosList.map((contrato: ContractDTO) => (
          <Card
            key={contrato.idContrato}
            variant="outlined"
            sx={{
              px: { md: '3em', xs: '1em' },
              display: 'flex',
              flexDirection: 'column',
              padding: '10px',
              margin: '20px 22px 22px',
              alignItems: 'flex-start'
            }}
            elevation={4}
          >
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                width: '100%',
                marginBottom: '10px'
              }}
            >
              <Box
                sx={{
                  flexDirection: 'column',
                  flexGrow: 1,
                  fontSize: 16,
                  textAlign: 'left'
                }}
              >
                <div style={{ fontSize: '20px', fontWeight: 'bold' }}>{contrato.productoNombre}</div>
              </Box>

              <div
                style={{
                  backgroundColor: `#${contrato.color}`,
                  color: 'white',
                  border: 'none',
                  borderRadius: '5px',
                  padding: '3px 8px',
                  cursor: 'pointer',
                  fontSize: '16px'
                }}
              >
                {contrato.estadoNombre}
              </div>
            </Box>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                width: '100%',
                marginBottom: '10px'
              }}
            >
              <Box
                sx={{
                  flexDirection: 'column',
                  flexGrow: 1,
                  fontSize: 16,
                  textAlign: 'left',
                  whiteSpace: 'nowrap'
                }}
              >
                <div style={{ fontSize: '16px' }}>Desde: {contrato.fechaInicioFormateada} </div>
                <div style={{ fontSize: '16px' }}>Hasta: {contrato.fechaFinFormateada} </div>
                {contrato.accionesUsuarioList &&
                  contrato.accionesUsuarioList[0].payload?.datosTransferencia?.titular && (
                    <Typography>{`Titular: ${contrato.accionesUsuarioList[0].payload?.datosTransferencia?.titular}`}</Typography>
                  )}
              </Box>
            </Box>
            {contrato.accionesUsuarioList && contactoLocal && (
              <Button
                variant="contained"
                fullWidth
                style={{
                  backgroundColor: contrato.accionesUsuarioList[0]?.color,
                  border: '1px solid grey',
                  color: 'black',
                  marginTop: '20px'
                }}
                onClick={() => handleClick(contrato.accionesUsuarioList[0])}
              >
                {contrato.accionesUsuarioList[0].boton}
              </Button>
            )}
          </Card>
        ))}
      </Container>
    </>
  )
}

export default DisplayContractsMobile
